import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { OperatingRegionsPage } from '@/pages/regions/OperatingRegionsPage'

const regionsSearchZod = z.object({
  showTest: z
    .union([z.boolean(), z.literal(''), z.literal('true'), z.literal('false')])
    .optional()
    .transform((v) => v === true || v === '' || v === 'true' || (v === undefined && import.meta.env.DEV)),
  date: z.string().optional(), // YYYY-MM-DD format, undefined = live mode
})

export const Route = createFileRoute('/regions/')({
  component: withErrorBoundary(OperatingRegionsPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: regionsSearchZod,
})
